<template>
    <div
        class="VLoadingRow"
        :style=" {
            height: height,
            width: width,
            marginBottom:mb
          }"
    >
    </div>
</template>

<script>
    
    export default {
        name: 'VLoadingRow',
        props: {
            width: {
                type: String,
                required: false,
            },
            height: {
                type: String,
                required: false,
            },
            mb: {
                type: String,
                required: false,
            },
        },
    };
</script>

<style
    scoped
    lang="scss"
>
    .VLoadingRow {
        width: 100%;
        height: 100%;
        @include loading-animation;
    }
</style>